import * as EVENT from "./eventKeys";

export const generateFilterUrl = (filters) => {
    let mappings = {}, params = [], url = '';
    if (filters && Object.keys(filters)?.length > 0) {
        Object.keys(filters)
            .map(filterKey => {
                if ((filters?.[filterKey] || filters?.[filterKey] === 0))
                    mappings = {...mappings, ...filters}
                else {
                    delete filters[filterKey]
                    mappings = {...filters}
                }
                if (Array.isArray(filters?.[filterKey])) {
                    if (filters?.[filterKey])
                        delete filters[filterKey]
                    mappings = {...filters}
                }
            })
        params = createQueryParamUrl(mappings).join("");
        url = params;
    }
    return url
}
export const createQueryParamUrl = (filterKeys) => {
    let params = []
    try {
        let filterKeysArray = Object.keys(filterKeys)
        filterKeysArray.map(((key, index) => {
            if (filterKeys[key] !== null) {
                params.push(`${key}=${filterKeys[key]}${index !== filterKeysArray?.length - 1 ? '&' : ''}`)
            }
        }));
    } catch (e) {

    }
    return params
}

export const getSourcePage = (path) =>{
    switch(path)
    {
        case 'Activities':
        case '/activities':
            return EVENT.SOURCE_PAGE_ACTIVITIES;
        case 'News':
        case '/news':
            return EVENT.SOURCE_NEWS_FREAD_PAGE;
        case 'Leaderboard':
        case '/Leaderboard':
            return EVENT.SOURCE_LEADER_BOARD_PAGE;
        case '/collection/:id':
            return EVENT.SOURCE_PAGE_COLLECTION;
        case 'Stories':
        case '/story':
            return EVENT.SOURCE_STORY_READING;
        case 'Feed':
        case '/':
            return EVENT.SOURCE_FEED_PAGE;
        case 'Play':
        case '/quiz':
            return EVENT.SOURCE_PLAY_PAGE;
        case 'fLIVE':
        case '/user':
        case '/profile-complete':
        case '/student/profile':
            return EVENT.SOURCE_STUDENT_DASHBOARD_PAGE;
        default:
            return EVENT.SOURCE_FEED_PAGE;
    }
}

export const formatDate = (date) => {
  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const dayOfWeek = days[date.getDay()];
  const month = months[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes();

  // Format hours and minutes
  const formattedHours = hours % 12 || 12;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  const period = hours < 12 ? "AM" : "PM";

  return `${dayOfWeek}, ${month} ${day}, ${year} ${formattedHours}:${formattedMinutes} ${period}`;
};

export const IRO_GRADES = [
    "Grade 1",
    "Grade 2",
    "Grade 3",
    "Grade 4",
    "Grade 5",
    "Grade 6",
    "Grade 7",
    "Grade 8",
];

export const READ_ALOUD_COLLECTION_ID = '73bee548-dcae-4587-9398-ce2f2a624589'

export const withTimeout = (promise, timeoutMs = 6000, error) => {
    return Promise.race([
        promise,
        new Promise((_, reject) =>
            setTimeout(() => reject(new Error(error)), timeoutMs)
        )
    ]);
};


export const sortData = (data, key) => {
    let sortedData = data?.sort((a, b) => {
        if (a[key] < b[key]) {
            return -1;
        }
        if (a[key] > b[key]) {
            return 1;
        }
        return 0;
    });

    return sortedData;
};

const NUMBER_WORDS = [
    "Zero", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
    "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen",
    "Seventeen", "Eighteen", "Nineteen", "Twenty", "", "", "Thirty", "", "", "Forty",
    "", "", "Fifty", "", "", "Sixty", "", "", "Seventy", "", "", "Eighty", "", "", "Ninety"
];

export const convertNumberToWords = (amt) => {
    const amount = amt.toString();
    const atemp = amount.split(".");
    const number = atemp[0].split(",").join("");
    const n_length = number.length;

    if (n_length > 9) return "";

    const n_array = new Array(9).fill(0);
    const received_n_array = number.split("");

    for (let i = 9 - n_length, j = 0; i < 9; i++, j++) {
        n_array[i] = parseInt(received_n_array[j]);
    }

    for (let i = 0, j = 1; i < 9; i++, j++) {
        if ((i === 0 || i === 2 || i === 4 || i === 7) && n_array[i] === 1) {
            n_array[j] = 10 + n_array[j];
            n_array[i] = 0;
        }
    }

    let words_string = "";
    for (let i = 0; i < 9; i++) {
        const value = (i === 0 || i === 2 || i === 4 || i === 7) ? n_array[i] * 10 : n_array[i];

        if (value !== 0) {
            words_string += NUMBER_WORDS[value] + " ";
        }

        if ((i === 1 && value !== 0) || (i === 0 && value !== 0 && n_array[i + 1] === 0)) {
            words_string += "Crores ";
        }
        if ((i === 3 && value !== 0) || (i === 2 && value !== 0 && n_array[i + 1] === 0)) {
            words_string += "Lakhs ";
        }
        if ((i === 5 && value !== 0) || (i === 4 && value !== 0 && n_array[i + 1] === 0)) {
            words_string += "Thousand ";
        }
        if (i === 6 && value !== 0) {
            words_string += n_array[i + 1] !== 0 && n_array[i + 2] !== 0 ? "Hundred and " : "Hundred ";
        }
    }

    return words_string.replace(/\s+/g, " ").trim();
};

// UUID validation regex
const UUID_REGEX = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

// Extract ID from pathname
export const extractIdFromPathname = (pathname) => {
    if (!pathname) return null;
    const parts = pathname.split("/");
    const lastPart = parts[parts.length - 1];
    return UUID_REGEX.test(lastPart) ? lastPart : null;
};

export const generateDeviceId = () => {
  const navigatorInfo = window.navigator;
  const screenInfo = window.screen;
  const uid =
    navigatorInfo.mimeTypes.length +
    navigatorInfo.userAgent.replace(/\D+/g, "") +
    navigatorInfo.plugins.length +
    screenInfo.height +
    screenInfo.width +
    screenInfo.pixelDepth;
  return uid;
}